import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import CourseSectionSchedulerLocationService from "../../../Services/CourseSectionSchedulerLocation.service";
import LocationService from "../../../Services/Location.service";
import DeprecatedSelect from "../../UI/DeprecatedSelect/DeprecatedSelect";
import useUniqueId from "../../Hooks/useUniqueId";
const LocationSchedulerSidebar = ({ selectedLocations, onSetSelectedLocations, }) => {
    const makeId = useUniqueId()[1];
    return (_jsxs("div", { className: "p-2", children: [_jsx("p", { children: "Filter the course sections you would like to schedule by location:" }), _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: makeId("locations"), children: "Locations" }), _jsx(DeprecatedSelect.Async, { id: makeId("locations"), multi: true, value: selectedLocations, clearable: false, onChange: (values) => {
                            const additions = values.filter(
                            // @ts-expect-error - TS7006 - Parameter 'val' implicitly has an 'any' type.
                            (val) => !selectedLocations.map((loc) => loc.id).includes(val.id));
                            const deletions = selectedLocations.filter(
                            // @ts-expect-error - TS7006 - Parameter 'val' implicitly has an 'any' type.
                            (loc) => !values.map((val) => val.id).includes(loc.id));
                            // TODO make this transactional
                            Promise.all(additions
                                // @ts-expect-error - TS7006 - Parameter 'add' implicitly has an 'any' type.
                                .map((add) => CourseSectionSchedulerLocationService.addLocation(add.id))
                                .concat(deletions.map((del) => CourseSectionSchedulerLocationService.removeLocation(del.id)))).then(() => {
                                onSetSelectedLocations(values);
                            });
                        }, loadOptions: (query) => LocationService.getLocations(query).then((locs) => ({
                            options: locs,
                        })), valueKey: "id", labelKey: "name" })] })] }));
};
export default LocationSchedulerSidebar;
